import cx from 'classnames';

import s from './OrganicButton.module.css';

type TProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  selected?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const OrganicButton = ({
  children,
  className,
  disabled = false,
  selected = false,
  onClick,
  ...otherProps
}: TProps) => (
  <button
    className={cx(s.button, className, {
      [s.selected]: selected,
    })}
    disabled={disabled}
    onClick={onClick}
    {...otherProps}
  >
    {children}
  </button>
);
